import { FunctionComponent, ReactNode } from "react";
import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

import { applicationConfig } from "../../environmentConfiguration";
import { msalConfig } from "../auth-config";
import { TokenRefreshManager } from "../TokenRefreshManager";

interface IAuthProviderProps {
  children: ReactNode;
}

const newMsalInstance = new PublicClientApplication(msalConfig);
TokenRefreshManager.initialize(newMsalInstance, {
  apiPermissionScopes: applicationConfig.permissionScopes,
});

const accounts = newMsalInstance.getAllAccounts();
if (accounts.length > 0 && !newMsalInstance.getActiveAccount()) {
  newMsalInstance.setActiveAccount(accounts[0]);
}

// Listen for sign-in event and set active account
newMsalInstance.addEventCallback((event: EventMessage) => {
  const authenticationResult = event.payload as AuthenticationResult;
  const account = authenticationResult?.account;
  if (event.eventType === EventType.LOGIN_SUCCESS && account) {
    newMsalInstance.setActiveAccount(account);
  }
});

const AuthProvider: FunctionComponent<IAuthProviderProps> = ({ children }: IAuthProviderProps) => {
  if (!newMsalInstance) {
    return null;
  }

  return <MsalProvider instance={newMsalInstance}>{children}</MsalProvider>;
};

export const getMsalInstance = (): PublicClientApplication => newMsalInstance;

export const useAuthProvider = () => {
  return { AuthProvider };
};
